// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__7k0Zq","collapsed":"Sidebar_collapsed__QWzOB","logo":"Sidebar_logo__awPjl","navLinks":"Sidebar_navLinks__wPMfj","logout":"Sidebar_logout__zn1SC"};